
export const PUBLIC_PROFILE_ERROR_NICK = 'Choose different username';
export const PUBLIC_PROFILE_TITLE = 'Public Profile';
export const PUBLIC_PROFILE_TITLE_CREATE = 'Create Public Profile';
export const PUBLIC_PROFILE_BIO_PLACEHOLDER = 'Write a brief description about yourself to be displayed on your public profile page';
export const PUBLIC_PROFILE_SUBMIT = 'Save profile';
export const PUBLIC_PROFILE_SUBMIT_CREATE = 'Create public profile';
export const PUBLIC_PROFILE_SHOW_AVATAR = 'Show Google account avatar';
